import { getData, postData } from '@/assets/js/api.js'

// 查询IFTTT列表（执行自动化查找）
export const FindList = (params, fn) => {
  const methods = '/api/IFttt/ChooseList'
  getData(methods, params, 1, fn)
}

//查询IFTTT和HCL列表（执行自动化查找）
export const ChooseHclAndIFtttList = (params,fn) => {
	let methods = '/api/IFttt/ChooseHclAndIFtttList';
	getData(methods, params, 1, fn);
};

//窜寻IFTTT列表
export const FindListToList = (params,fn) => {
	let methods = '/api/IFttt/FindList';
	getData(methods, params, 1, fn);
};
//窜寻IFTTT列表
export const FindListToListByPage = (params,fn) => {
	let methods = '/api/IFttt/FindListByPage';
	return getData(methods, params, 1, fn);
};

// 窜寻IFTTT组列表
export const FindListToListByGroup = (params, fn) => {
  // const methods = '/api/IFttt/FindIFtttListByGroupId'
  const methods = '/businessapi/AutoTemplate/GetAutoTemplateWithDeviceList'
  getData(methods, params, 1, fn)
}

// 创建IFTTT
export const Create = (params, fn) => {
  const methods = '/api/IFttt/Create'
  return postData(methods, params, 1, fn)
}

//自动化4.0 创建
export const CreateTimeSequence = (params, fn) => {
  const methods = '/api/IFttt/CreateTimeSequence'
  return postData(methods, params, 1, fn)
}

// 自动化4.0 编辑
export const EditTimeSequence = (params, fn) => {
  const methods = '/api/IFttt/EditTimeSequence'
  return postData(methods, params, 1, fn)
}



// batch创建IFTTT
export const BatchCreate = (params, fn) => {
  const methods = '/api/IFttt/BatchCreate'
  return postData(methods, params, 1, fn)
}

export const BatchDeletev1 = (params, fn) => {
  const methods = '/api/IFttt/BatchDeletev1'
  return postData(methods, params, 1, fn)
}

// batch创建IFTTT
export const BatchEdit = (params, fn) => {
  const methods = '/api/IFttt/BatchEdit'
  postData(methods, params, 1, fn)
}

// 开启IFTTT
export const Open = (params, fn) => {
  const methods = '/api/IFttt/Open'
  getData(methods, params, 1, fn)
}

// 关闭IFTTT
export const Close = (params, fn) => {
  const methods = '/api/IFttt/Close'
  getData(methods, params, 1, fn)
}

// 删除
export const Delete = (params, fn) => {
  const methods = '/api/IFttt/Delete'
  return getData(methods, params, 1, fn)
}

// 批量删除
export const GroupDelete = (params, fn) => {
  const methods = '/api/IFTTT/BatchRemove'
  postData(methods, params, 1, fn)
}

// 历史看板
export const ShowIftttHistorySyncResult = (params, fn) => {
  const methods = '/api/IFttt/ShowHistorySyncResult'
  getData(methods, params, 1, fn)
}

// 当前看板
export const ShowIftttCurrentSyncResult = (params, fn) => {
  const methods = '/api/IFttt/ShowCurrentSyncResult'
  getData(methods, params, 1, fn)
}

// 查询用户设置的IFTTT详情
export const Find = (params, fn) => {
  const methods = '/api/IFttt/Find'
  return getData(methods, params, 1, fn)
}

// 编辑ifttt
export const Edit = (params, fn) => {
  const methods = '/api/IFttt/Edit'
  postData(methods, params, 1, fn)
}

// 重新下发配置 - 自动化
export const ReSyncIftttDeviceConfig = (params, fn) => {
  const methods = '/api/IFttt/ReSyncDeviceConfig'
  getData(methods, params, 1, fn)
}
// 重新下发配置 - 恒照度
export const ReSyncConstIlluminationConfig = (params, fn) => {
  const methods = '/api/constIllumination/ReSyncDeviceConfig'
  getData(methods, params, 1, fn)
}
// 重新下发配置 - 节律
export const ReSyncRhythmConfig = (params, fn) => {
  const methods = '/api/rhythm/ReSyncDeviceConfig'
  getData(methods, params, 1, fn)
}

// 手动执行
export const Call = (params, fn) => {
  const methods = '/api/IFttt/Call'
  getData(methods, params, 1, fn)
}
export const CallIfttt = (params, fn) => {
  Call(params, fn)
}

// 获取区域下的自动化列表
export const GetIFtttListInArea = (params, fn) => {
  const methods = '/api/IFttt/GetIFtttListInArea'
  getData(methods, params, 1, fn)
}

// 查看区域下是否有自动化
export const GetIFtttCount = (params, fn) => {
  const methods = '/api/IFttt/GetIFtttCount'
  getData(methods, params, 1, fn)
}

// 获取设备trigger能力
export const FindIFtttListByTrigger = (params, fn) => {
  const methods = '/api/IFttt/FindIFtttListByTrigger'
  return getData(methods, params, 1, fn)
}
// 获取自动化模版列表
export const GetAutoTemplateList = (params, fn) => {
  const methods = '/businessapi/AutoTemplate/GetAutoTemplateList'
  getData(methods, params, 1, fn)
}
// 获取支持自动化模版设备列表
export const GetAutoTemplateWithDeviceList = (params, fn) => {
  // fn({
  //   Result: iftttData,
  //   StatusCode: '0',
  //   Message: '成功'
  // })
  const methods = '/businessapi/AutoTemplate/GetAutoTemplateWithDeviceList'
  getData(methods, params, 1, fn)
}

// 获取支持自动化模版设备列表
export const getSwitchKeyEventList = (params = {}) => {
  const methods = '/api/Device/GetSwitchKeyEventList';

  return getData(methods, params, 1)
}

export const setSwitchKeyName = (params = {}) => {
  const methods = '/api/Device/SetSwitchKeyName';

  return postData(methods, params, 1)
}

// 获取支持自动化模版设备列表
export const GetImageList = (params = {}) => {
  const methods = '/api/Common/GetImageList?type=scene';

  return getData(methods, params, 1)
}

// 图片资源
export const GetImageSenceList = (type) => {
  const methods = `/api/Common/GetImageList?type=${type}`;

  return getData(methods, {}, 1)
}

/**
 * 批量开启区域下的IFTTT（恒照度，日程，节律，定时）
 * @param {Object} params
 * @param {number} params.gpNo
 */
export const batchOpenIftttByGpNo = (params = {}) => {
  return getData('/api/IFttt/BatchOpenByGpNo', params, 1)
}

/**
 * 批量关闭区域下的IFTTT（恒照度，日程，节律，定时）
 * @param {Object} params
 * @param {number} params.gpNo
 */
export const batchCloseIftttByGpNo = (params = {}) => {
  return getData('/api/IFttt/BatchCloseByGpNo', params, 1)
}

/**
 * 缓存机制 且首次并发请求 只取一次数据
 */
class GetImageListProxy {
  imgList = null;
  
  promiseList = [];

  isRequest = false;

  async requestImageList() { 
    if (this.imgList) return this.imgList;
  
    if (this.isRequest) {
      return new Promise((resolve) => {
        this.promiseList.push((data) => { 
          resolve(data);
        })
      })
    }

    try {
      this.isRequest = true;

      const res = await GetImageList();

      this.imgList = res.Result;

      this.promiseList.forEach(fn => fn(this.imgList));

      return this.imgList
    } catch (e) { 

    }
  }
}

export const getImageListProxy = new GetImageListProxy();
// 查询通知故障分页 http://10.0.96.200:18821/swagger/index.html
// export const queryMessageByPage = (params) => {
//   const methods = '/MessageCenter/QueryMessageByPage';

//   return postData(methods, params);
// }

// 批量开启区域下的IFTTT
export const BatchOpenByGpNo = (params) => {
  const methods = '/api/IFttt/BatchOpenByGpNo'
  return getData(methods, params, 1)
}
// 批量关闭区域下的IFTTT
export const BatchCloseByGpNo = (params) => {
  const methods = '/api/IFttt/BatchCloseByGpNo'
  return getData(methods, params, 1)
}

// 检查自动化涉及网关和WIFI设备支持自动化3.0的情况
export const CheckIfttt3SupportStatusInModel = (params, fn) => {
  const methods ='/api/IFttt/CheckIfttt3SupportStatusInModel'
  return postData(methods, params, 1, fn)
}

//获取所选区域的自动化
export const FindListInAreasByPage = (params, fn) => {
  const methods = '/api/IFttt/FindListInAreasByPage'
  return getData(methods, params, 1, fn)
}

// 自动化诊断接口
export const PerformIftttDiagnosis = (params, fn) => {
  const methods = '/api/IFttt/PerformIftttDiagnosis'
  return getData(methods, params, 1, fn)
}


// 场景自动化数据恢复列表
export const SceneRecoverList = (params) => {
  const methods = '/businessapi/Scene/SceneRecoverList'

  return postData(methods, params, 1)
}

// 获取自动化恢复详情
export const IFtttRecoverDetail = (params) => {
  const methods = '/businessapi/IFttt/IFtttRecoverDetail'

  return getData(methods, params, 1);
}

export const Recover = (params) => {
  const methods = '/api/IFttt/Recover'

  return postData(methods, params, 1)
}

export const DeleteIFtttRecover = (params) => {
  const methods = '/businessapi/IFttt/DeleteIFtttRecover';

  return getData(methods, params, 1);
}

//查询区域下策略列表
export const FindStrategyList = (params) => {
  const methods = '/api/ifttt/FindStrategyList';
  return getData(methods, params, 1);
}

//创建策略
export const CreateStrategy = (params) => {
  const methods = '/api/ifttt/CreateStrategy';
  return postData(methods, params, 1);
}

//编辑策略
export const EditStrategy = (params) => {
  const methods = '/api/ifttt/EditStrategy';
  return postData(methods, params, 1);
}

//删除策略删除策略
export const DeleteStrategy = (params) => {
  const methods = '/api/ifttt/DeleteStrategy';
  return getData(methods, params, 1);
}

//开启策略
export const OpenStrategy = (params) => {
  const methods = '/api/ifttt/OpenStrategy';
  return getData(methods, params, 1);
}

//关闭策略
export const CloseStrategy = (params) => {
  const methods = '/api/ifttt/CloseStrategy';
  return getData(methods, params, 1);
}